import { gql } from "@apollo/client";

export const FETCH_MARKETTIME_PRODUCTS = gql`
  query FETCH_MARKETTIME_PRODUCTS {
    mtProducts
  }
`;

export const FETCH_ODOO_MT_PRODUCTS = gql`
  query FETCH_ODOO_MT_PRODUCTS {
    odooProducts(instance: "INC", fields: ["x_studio_markettime_product_id"])
  }
`;

export const ODOO_SAVE_PRODUCT = gql`
  mutation ODOO_SAVE_PRODUCT(
    $instance: String!
    $odooProductId: Int!
    $xStudioMarkettimeProductId: ID
  ) {
    odooSaveProduct(
      instance: $instance
      odooProductId: $odooProductId
      xStudioMarkettimeProductId: $xStudioMarkettimeProductId
    ) {
      result
    }
  }
`;
